const shop = {
  shopname: "ชื่อร้าน",
  contacts: "ผู้ติดต่อ",
  shopnamewidth: "60px",
  contactswidth: "65px",
  mobilewidth: "145px",
  logo: "โลโก้",
  mobile: "เบอร์ติดต่อ",
  shoptime: "เวลาทำการ",
  address: "ที่อยู่",
  addshop: "เพิ่มร้านค้า",
  editshop: "แก้ไขร้านค้า",
  baseMessage: "ข้อมูลพื้นฐาน",
  otherMessage: "ข้อมูลอื่น ๆ",
  jianjie: "คำอธิบายธุรกิจ",
  uploadImg: "อัพโหลดรูปร้าน",
  formLeftWidth: "120px",
  formDetailWidth: "130px",
  photo: "โปรดอัปโหลดรูปภาพ JPG / JPEG / PNG / GIF / SVG / BMP",
  tips: "กรุณาใส่",
  tipsLength: "ความยาวอักขระต้องไม่เกิน",
  uploadLOGO: "อัปโหลด LOGO",
  detailTitle: "รายละเอียดร้านค้า",
  shopLink: "ลิงค์ร้านค้า"
} 
export default shop